//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fetchFilter} from "@/api/master";
import {fetchReceiveBookList} from "@/api/receiveBook"
import {Message} from "element-ui";
import func from "@/utils/decoded";
import {fetchReportStep3} from "@/api/report";
import moment from "moment/moment";

const fields = [
	{key: 'contract_id', label: 'เลขที่สัญญา', _style: 'min-width:100px'},
	{key: 'name_customer', label: 'ชื่อ-สกุล', _style: 'min-width:150px;'},
	{key: 'start_date_contract', label: 'วันที่เริ่มทำสัญญา', _style: 'min-width:100px;'},
	{key: 'balance', label: 'ยอดเงินคงเหลือ', _style: 'min-width:100px; text-align: right;'},
	{key: 'cur_status_id', label: 'สถานะ', _style: 'min-width:100px;'},
	{key: 'process_day', label: 'เวลาดำเนินการ(วัน)', _style: 'min-width:50px; text-align: right;'},
	{
		key: 'show_details',
		label: 'รายละเอียด',
		_style: 'min-width:150px; text-align: center;',
		sorter: false,
		filter: false
	}
]

export default {
	name: 'CarRegistration',
	title: 'test',
	data() {
		return {
			options: [],
			show: true,
			isCollapsed: true,
			items: [],
			fields,
			filterParams: {
				stepId: 3
			},
			searchParams: {
				keyword: '',
				startDate: '',
				endDate: '',
				filter: 0
			},
			privilege: {read: false, write: false, report: false}
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page)
				}
			}
		}
	},

	async mounted() {
		this.$store.state.loading = true
		try {
			this.searchParams.endDate = moment().format('YYYY-MM-DD')
			this.searchParams.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD')
			await new Promise((resolve, reject) => {
				fetchFilter(this.filterParams).then(response => {
					const check = response.header
					const data = response.body
					if (check.error === 'N') {
						this.options = data

						console.log('filter : ', this.options);
						resolve()
					}
				}).catch(error => {
					this.errorMsg = error
					console.log(error)
					reject(error)
				})
			})
			await this.getReceiveBookList()
		} finally {
			this.$store.state.loading = false
		}

		const check = func.checkMenu(this.$route.path)
		if (check && check.length > 0) {
			this.privilege = check[0]
		}
	},

	methods: {
		async getReceiveBookList() {
			console.log('searchParams : ', this.searchParams);
			await fetchReceiveBookList(this.searchParams).then(res => {
				this.items = []
				const check = res.header;
				const data = res.body;
				if (check.error == 'N') {
					for (let item of data) {
						if (item.cur_status_id == 2 && item.cur_step == 2) {
							item.cur_status = 'วางชุดโอน[เรียบร้อย]'
						} else if (item.cur_status_id == 1 && item.cur_step == 3) {
							item.cur_status = 'รับเล่มทะเบียน[ไม่เรียบร้อย]'
						} else if (item.cur_status_id == 2 && item.cur_step == 3) {
							item.cur_status = 'รับเล่มทะเบียน[เรียบร้อย]'
						} else if (item.cur_status_id == 0 && item.cur_step == 3) {
							item.cur_status = 'รับเล่มทะเบียน[ข้ามขั้นตอน]'
						}
						this.items.push(item);
					}
				}
			}).catch(error => {
				Message({
					message: 'มีข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ',
					type: 'error',
					duration: 5 * 1000,
				})
				this.errorMsg = error
				console.log(error)
			})
		},
		getBadge(status, step) {
			switch (status) {
				case 2:
					if (step === 3) return 'success'; else return 'warning';
				case 0:
					return 'warning'
				case 1:
					return 'danger'
				default:
					return 'primary'
			}
		},
		handleContractExport() {
			const loading = this.$loading({
				lock: true,
				text: 'Please wait',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			fetchReportStep3(this.searchParams).then(response => {
				const fileURL = window.URL.createObjectURL(new Blob([response]))
				const fileName = 'Step3_' + func.generateReportDate() + '.xlsx'
				const link = document.createElement('a')

				link.href = fileURL
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				loading.close()
				if (response.size > 0 && response.type !== 'application/json') {
					link.click()
				} else {
					this.$notify({
						title: 'Error',
						message: 'ไม่สามารถสร้างรายงานการรับเล่มทะเบียน',
						type: 'error',
						duration: 5000
					})
				}
				link.remove()

				// Just to simulate the time of the request
				setTimeout(() => {
					loading.close()
				}, 1.5 * 1000)
			})
		},
		rowClickDetail(item) {
			this.$router.push({path: `/step3/CarRegistrationDetail/${item.contract_id}`})
		},
		pageChange(val) {
			this.$router.push({query: {page: val}})
		}
	}
}
